import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getUserSettings = () => call(websocketFetch, 'get_user_settings');
